module.exports = __webpack_public_path__ + "img/target_protection.d9fa2cc3.svg";